import { PortalkonfigurationDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { StammdatenService } from '@/core/services/stammdaten.service';
import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalkonfigurationResolver implements Resolve<PortalkonfigurationDisplayModel | null> {
  constructor(protected stammdatenService: StammdatenService){

  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<PortalkonfigurationDisplayModel | null> {
    return this.stammdatenService.GetPortalKonfiguration();
  }
}
